import ValidatedAddresses from './ValidatedAddresses'
export default ValidatedAddresses